module.exports = __webpack_public_path__ + "img/tn-timeline-main-16.6f3c40c3.jpg";